import { wqkgx } from '../config/keys';
import CryptoJS from 'crypto-js';

export const decryptJson = (data: any) => {
  if (data) {
    const text = CryptoJS.AES.decrypt(data, wqkgx);
    return JSON.parse(text.toString(CryptoJS.enc.Utf8));
  } else {
    return {};
  }
};
